import { Input, InputNumber } from "antd";

export const FIELD_TYPES = {
  number: {
    type: "number",
    component: (props) => <InputNumber {...props} />,
  },
  text: {
    type: "text",
    component: (props) => <Input {...props} />,
  },
};

export const STYLES = {
  fontSize: {
    sm1: "0.25rem",
    sm2: "0.375rem",
    sm3: "0.5rem",
    md1: "1rem",
    md2: "1.25rem",
    md3: "1.5rem",
    lg1: "2rem",
    lg2: "3rem",
    lg3: "4rem",
  },
};

export const DOCK_TYPES = {
  Barc: { label: "Barc", value: "Barc" },
  Bike: { label: "Bike", value: "Bike" },
  Buggy: { label: "Buggy", value: "Buggy" },
  Other: { label: "Other", value: "Other" },
};

export const SOCKET_EMITS = {
  notification: "notification",
  new_barc_ride: "new_barc_ride",
};
